module.exports = __webpack_public_path__ + "img/06.904b8c28.png";